export const footer_list=[
    {
        title: 'contatti',
        info:[
            'tincisioni@gmail.com',
            '+39 327 3511968',
            'via Guido Rossa 24 Zola Predosa (BO)',
        ],
    }
]